import {axiosConfigNew as axios} from "../../../utils/axios";

export const apiExam = (body: any) => axios.get(`/edu/exams`, {
  params: body
}).then(({data}) => data);
